<template>
  <div
    v-if="generalStore.uiBlocked"
    data-testid="ui-blocked-overlay"
    class="fixed left-0 top-0 z-[10000] grid h-full w-full items-center justify-center bg-black/[.6]"
  >
    <TLoadingSpinner extra-large />
  </div>
</template>

<script lang="ts" setup>
  import { TLoadingSpinner } from "@topol/twig-ui";
  import { useGeneralStore } from "@/stores/generalStore";

  const generalStore = useGeneralStore();
</script>
